import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

// elements

import LanguageToggle from '~/components/LanguageToggle'
import PageTitle from '~/components/PageTitle'
import Svg from '~/components/svg'
import { useAppInfo } from '~/hooks/useAppInfo'

import LoginForm from '../../components/LoginForm'

import * as S from './styles'

const Login = () => {
  const { t } = useTranslation()
  /**
   * Handle app info
   */
  const { logo: urlLogo, name } = useAppInfo()
  /**
   * END = Handle app info
   */

  const { search } = useLocation()
  // const params = new URLSearchParams(search)

  // useEffect(() => {
  //   if (params?.get('revalidate') === 'token') {
  //     params.delete('revalidate')
  //     history.push({ search: params.toString() })
  //   }
  // }, [params])

  const hasPath = search.indexOf('callback_url=/shopping-carts/review-bar/')

  return (
    <>
      {hasPath < 0 ? (
        <>
          <PageTitle title="Login" />

          <S.Container className="m-auto px-5 bg-white border rounded-3">
            <header>
              {urlLogo ? (
                <img
                  src={urlLogo}
                  alt={name}
                  width="auto"
                  height="28"
                  className="object-fit-contain"
                  style={{ marginBottom: '2rem' }}
                />
              ) : (
                <Svg
                  src="brands/logo-vtex-ads"
                  width="auto"
                  height="28"
                  style={{ width: 'auto', marginBottom: '2rem' }}
                />
              )}

              <div>
                <h3>{t('auth:login.welcome.title')}</h3>
                <p>{t('auth:login.welcome.message')}</p>
              </div>
            </header>

            <LoginForm />

            <footer style={{ marginTop: '1.25rem' }}>
              <LanguageToggle />
            </footer>
          </S.Container>

          {/* <div className="login"> */}
          {/* <LoginForm /> */}
          {/* <LoginSlider /> */}
          {/* </div> */}
        </>
      ) : (
        <S.ContainerReviewCart>
          <span>
            Para revisar o carrinho você precisa efetuar login na plataforma
            Newtail.{' '}
            <Link to="/login" target="_blank">
              Faça o login
            </Link>{' '}
            e atualize essa página.
          </span>
        </S.ContainerReviewCart>
      )}
    </>
  )
}

export default Login
